import { SearchList } from '@playbooks/molecules/lists';
import { SectionPanel, SectionPanelBody, SectionPanelFooter } from '@playbooks/molecules/panels/section-panel';
import { Icon } from '@playbooks/ui/components/icon';
import { Link } from '@playbooks/ui/components/link';

import { SearchSearchCard } from 'components/search/search-card';

const SearchResultsAll = ({ query, hits, loading, onClick, className = '' }) => {
	// Render
	return (
		<SectionPanel>
			<SectionPanelBody className='py-3'>
				<SearchList
					layout='search'
					data={hits}
					loading={loading}
					icon='magnifying-glass'
					title='Search Results'
					className={className}>
					{hits.map((hit, index) => (
						<div key={index}>
							<SearchSearchCard hit={hit} onClick={onClick} className='p-4' />
						</div>
					))}
				</SearchList>
			</SectionPanelBody>
			<SectionPanelFooter>
				<Link variant='outline' size='sm' href={`/search?query=${query}`} className='w-full'>
					View All
					<Icon data-icon='inline-end' type='far' icon='chevron-right' aria-hidden />
				</Link>
			</SectionPanelFooter>
		</SectionPanel>
	);
};
export { SearchResultsAll };
